import React from 'react';

export default () => (
  <svg width="72" height="34" viewBox="-1 -1 74 36" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <path fill="#D6DCE4" d="M0 0h72v34H0z" />
          <path d="M31 23V12l11 5.5L31 23z" fill="#FFF" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/video-preview-widget.es6.js